import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBo5BKRzAsXJ7uNw3e4_5fTaFy1nUwnRr0",
  authDomain: "dbos-core-stage.firebaseapp.com",
  projectId: "dbos-core-stage",
  storageBucket: "dbos-core-stage.firebasestorage.app",
  messagingSenderId: "273538020820",
  appId: "1:273538020820:web:2f5642fdd30b77a1e09241",
  measurementId: "G-N1R10JREX1"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

export const CLIENT_ID = 'GIDO_IE_0001';
export const SMARTSHOP_API = 'https://europe-west1-dbos-core-prod.cloudfunctions.net';
